import { v4 as uuidv4 } from 'uuid';
import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import {
  Document, Page, Text, StyleSheet, View, PDFViewer, Font,
} from '@react-pdf/renderer';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';
import apiClient from '../ApiClient/ApiClient';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// ---- DatePicker 用的 MUI TextField 包裝（只顯示 placeholder，無 label） ----
const DPInput = React.forwardRef(({ value, onClick, onChange, placeholder }, ref) => (
  <TextField
    size="small"
    fullWidth
    placeholder={placeholder}
    value={value}
    onClick={onClick}
    onChange={onChange}
    inputRef={ref}
  />
));
DPInput.displayName = 'DPInput';

export default function MatItemCard({ data }) {
  const [newData, setNewData] = useState(null);
  const [drawNum, setDrawNum] = useState('');
  const [DetaildrawNum, setDetaildrawNum] = useState('');
  const [name, setName] = useState('');
  const [detailData, setDetailData] = useState(null);
  const [model, setModel] = useState('資材卡');
  const [loading, setLoading] = React.useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [page, setPage] = useState(1);

  const setModelandGetDate = (newModel) => setModel(newModel);

  // 取得資材卡（右側）
  const GetMats = async (dn) => {
    setLoading(true);
    try {
      const res = await apiClient.get(`/MatCard/GetMats?drawNum=${dn}`);
      if (res.data.statusCode === 200) {
        setDetailData(res.data);
        setDetaildrawNum(dn);
      } else {
        alert('找不到資料');
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // 左側分頁
  const nextPage = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(`/MatCard/GetItems?page=${page + 1}`);
      if (res.data.statusCode === 200) {
        setNewData(res.data);
        setPage(page + 1);
      } else {
        alert('已經是最後一筆了');
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const prePage = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(`/MatCard/GetItems?page=${page - 1}`);
      if (res.data.statusCode === 200) {
        setNewData(res.data);
        setPage(page - 1);
      } else {
        alert('已經是最後一筆了');
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (t) => t.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* 外框：左右各 1% padding，中間 gap 2%，兩欄各 48% */}
      <Box
  sx={{
    display: 'flex',
    gap: '2%',
    padding: '0 1%',
    marginTop: '24px',
    flexDirection: 'row-reverse',   // ← 加這行就會左右對調
  }}
>
        {/* 右欄：資材卡（先放右邊，符合你的草圖排列視覺） */}
        <Box sx={{ width: '48%' }}>
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <h2><span className="badge bg-dark">資材卡</span></h2>
          </Box>

          <DetailListPanel
            data={detailData}
            drawNum={DetaildrawNum}
            setDrawNum={setDetaildrawNum}
            setDetailData={setDetailData}
            setLoading={setLoading}
          />
        </Box>

        {/* 左欄：料品表 */}
        <Box sx={{ width: '48%' }}>
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <h2><span className="badge bg-dark">料品表</span></h2>
          </Box>

          <LeftFilterBar
            drawNum={drawNum}
            setDrawNum={setDrawNum}
            name={name}
            setName={setName}
            setNewData={setNewData}
            setHasSearched={setHasSearched}
            setLoading={setLoading}
          />

          <LeftItemsGrid
            rows={(newData || data)?.items || []}
            page={page}
            nextPage={nextPage}
            prePage={prePage}
            onShowMatCard={GetMats}
          />
        </Box>
      </Box>
    </>
  );
}

/* ---------------- 左側：查詢列（圖號 / 物品名 / 提交） ---------------- */
function LeftFilterBar({ drawNum, setDrawNum, name, setName, setNewData, setHasSearched, setLoading }) {
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const res = await apiClient.get(`/MatCard/GetItem?drawNum=${drawNum}&&name=${name}`);
      setNewData(res.data);
      setHasSearched(true);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', gap: 1, mb: 1 }}>
      <TextField
        fullWidth
        size="small"
        placeholder="圖號"
        value={drawNum}
        onChange={(e) => setDrawNum(e.target.value)}
      />
      <TextField
        fullWidth
        size="small"
        placeholder="物品名"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Button variant="contained" type="submit">提交</Button>
    </Box>
  );
}

/* ---------------- 左側：DataGrid（料品表） ---------------- */
function LeftItemsGrid({ rows, page, nextPage, prePage, onShowMatCard }) {
  const columns = [
    {
      field: 'actions',
      headerName: '操作',
      width: 90,
      sortable: false,
      renderCell: (params) => (
        <Button
          size="small"
          variant="outlined"
          onClick={() => onShowMatCard(params.row.drawNum)}
        >
          資材卡
        </Button>
      ),
    },
    { field: 'drawNum', headerName: '圖號', width: 140 },
    { field: 'itemName', headerName: '物品名', width: 180 },
    { field: 'unit', headerName: '單位', width: 90 },
    { field: 'specification', headerName: '規格', width: 200 },
    { field: 'safeAmount', headerName: '安全量', width: 110 },
    { field: 'inventory', headerName: '庫存量', width: 110 },
    { field: 'cost', headerName: '現有成本', width: 120 },
  ];

  return (
    <>
      <Box sx={{ height: '70vh' }}>
        <DataGrid
          rows={rows}
          getRowId={(r) => r.id ?? `${r.drawNum || ''}-${r.itemName || ''}`}
          columns={columns}
          pageSizeOptions={[20, 30, 40]}
          initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          disableRowSelectionOnClick
        />
      </Box>

      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Button className="btn btn-dark" onClick={prePage} disabled={page === 1} sx={{ mx: 1 }}>
          上一頁
        </Button>
        <span style={{ margin: '0 10px' }}>目前在第{page}頁</span>
        <Button className="btn btn-dark" onClick={nextPage} sx={{ mx: 1 }}>
          下一頁
        </Button>
      </Box>
    </>
  );
}

/* ---------------- 右側：資材卡 Panel（搜尋區 + DataGrid + PDF 預覽） ---------------- */
function DetailListPanel({ data, drawNum, setDrawNum, setDetailData, setLoading }) {
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [open, setOpen] = useState(false);
  const [comparisonOpen, setComparisonOpen] = useState(false);
  const [comparison, setComparison] = useState(null);
  const [comparisonLoading, setComparisonLoading] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleBatchDoubleClick = async (batchNo) => {
    if (!batchNo?.trim()) {
      window.alert('該筆資材卡缺少批號，無法進行訂單數量比對。');
      return;
    }
    if (!drawNum?.trim()) {
      window.alert('該筆資材卡缺少圖號，無法進行訂單數量比對。');
      return;
    }

    setComparisonLoading(true);
    try {
      const response = await apiClient.get('/MatCard/BatchComparison', {
        params: { batchNo: batchNo.trim(), drawNum: drawNum.trim() },
      });
      setComparison(response.data?.data || null);
      setComparisonOpen(true);
    } catch (error) {
      window.alert(error.response?.data?.message || '批號與訂單數量比對失敗。');
    } finally {
      setComparisonLoading(false);
    }
  };

  const handleTimeDetail = async () => {
    setLoading(true);
    try {
      const startStr = start ? dayjs(start).format('YYYY/MM/DD') : '';
      const endStr = end ? dayjs(end).format('YYYY/MM/DD') : '';
      const res = await apiClient.get(`/MatCard/TimeGetMats?drawNum=${drawNum}&start=${startStr}&end=${endStr}`);
      setDetailData(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = () => {
  const rows = data?.matCards || [];

  if (!rows.length) {
    alert('目前右側沒有資料可以匯出');
    return;
  }

  const excelData = rows.map((item, index) => ({
    '#': index + 1,
    '日期': item.date || '',
    '類別': item.kind || '',
    '單號': item.orderNum || '',
    '批號': item.piNum || '',
    '入量': item.inAmount ?? '',
    '出量': item.outAmount ?? '',
    '庫存量': item.stock ?? '',
    '核准': item.approve || '',
    '申請日期': item.applyDate || '',
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  worksheet['!cols'] = [
    { wch: 6 },
    { wch: 14 },
    { wch: 10 },
    { wch: 16 },
    { wch: 18 },
    { wch: 10 },
    { wch: 10 },
    { wch: 12 },
    { wch: 16 },
    { wch: 14 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, '資材卡');

  const fileName = `資材卡_${drawNum || '未指定圖號'}_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;

  XLSX.writeFile(workbook, fileName);
};

  const handleDeleteCMD = async (id) => {
    const confirmed = window.confirm(
      '確定要刪除這筆資材卡資料嗎？刪除後會重新計算後續結餘與料品庫存量。'
    );
    if (!confirmed) return;

    setLoading(true);
    try {
      await apiClient.delete('/MatCard/DeleteMats', { params: { id } });
      // 重新抓當前圖號的資材卡
      const res = await apiClient.get('/MatCard/GetMats', { params: { drawNum } });
      if (res.data.statusCode === 200) setDetailData(res.data);
      window.alert('刪除完成，資材卡結餘與料品庫存量已重新計算。');
    } catch (e) {
      console.error(e);
      if (e.response?.status === 403) {
        window.alert('權限不足，只有具審核權限的使用者可以刪除資材卡。');
      } else if (e.response?.status === 404) {
        window.alert('找不到要刪除的資材卡資料。');
      } else {
        window.alert('刪除失敗，請稍後再試。');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRecalculate = async () => {
    if (!drawNum?.trim()) {
      window.alert('請先從左側選擇要重新計算的圖號。');
      return;
    }

    const confirmed = window.confirm(
      `確定要重新計算圖號 ${drawNum} 的全部資材卡結餘與料品庫存量嗎？`
    );
    if (!confirmed) return;

    setLoading(true);
    try {
      const response = await apiClient.post('/MatCard/RecalculateByDrawNum', null, {
        params: { drawNum: drawNum.trim() },
      });
      const res = await apiClient.get('/MatCard/GetMats', {
        params: { drawNum: drawNum.trim() },
      });
      if (res.data.statusCode === 200) setDetailData(res.data);

      const result = response.data?.data;
      window.alert(
        `重新計算完成，共更新 ${result?.updatedCount ?? 0} 筆，最後庫存量為 ${result?.finalStock ?? 0}。`
      );
    } catch (e) {
      console.error(e);
      if (e.response?.status === 403) {
        window.alert('權限不足，只有具審核權限的使用者可以重新計算資材卡。');
      } else if (e.response?.status === 404) {
        window.alert(e.response?.data || '找不到該圖號的資材卡資料。');
      } else if (e.response?.status === 400) {
        window.alert(e.response?.data || '圖號資料不正確。');
      } else {
        window.alert('重新計算失敗，請稍後再試。');
      }
    } finally {
      setLoading(false);
    }
  };

  // 右側欄位
  const columns = [
    {
      field: 'ops',
      headerName: '#',
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <Button size="small" color="error" onClick={() => handleDeleteCMD(params.row.id)}>
          刪除
        </Button>
      ),
    },
    
    { field: 'date', headerName: '日期', width: 130 },
    { field: 'kind', headerName: '類別', width: 80 },
    { field: 'orderNum', headerName: '單號', width: 115 },
    {
      field: 'piNum',
      headerName: '批號',
      width: 150,
      renderCell: (params) => (
        <Box
          component="span"
          title="雙擊查看此批號的訂單與資材卡數量比對"
          onDoubleClick={(event) => {
            event.stopPropagation();
            handleBatchDoubleClick(params.row.piNum);
          }}
          sx={{ cursor: 'pointer', textDecoration: 'underline', width: '100%' }}
        >
          {params.row.piNum}
        </Box>
      ),
    },
    { field: 'inAmount', headerName: '入量', width: 100 },
    { field: 'outAmount', headerName: '出量', width: 100 },
    { field: 'stock', headerName: '庫存量', width: 110 },
    { field: 'approve', headerName: '核准', width: 140 },
    { field: 'applyDate', headerName: '申請日期', width: 130 },
  ];

  return (
    <>
      {/* 搜尋列：僅 placeholder 無 label */}
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <DatePicker
          selected={start}
          onChange={(d) => setStart(d)}
          dateFormat="yyyy/MM/dd"
          placeholderText="起始日"
          customInput={<DPInput placeholder="起始日" />}
        />
        <DatePicker
          selected={end}
          onChange={(d) => setEnd(d)}
          dateFormat="yyyy/MM/dd"
          placeholderText="終止日"
          customInput={<DPInput placeholder="終止日" />}
        />
        <Button variant="outlined" onClick={handleTimeDetail}>搜尋</Button>
        <Button variant="outlined" onClick={handleClickOpen}>列印</Button>
        <Button variant="outlined" color="success" onClick={handleExportExcel}>Excel</Button>
      </Box>

      {/* DataGrid */}
      <Box sx={{ height: '70vh' }}>
        <DataGrid
          rows={data?.matCards || []}
          getRowId={(r) =>
            r.id ??
            `${r.date || ''}-${r.orderNum || ''}-${r.piNum || ''}-${r.kind || ''}`
          }
          columns={columns}
          pageSizeOptions={[20, 30, 40]}
          initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          disableRowSelectionOnClick
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Button
          variant="contained"
          color="warning"
          onClick={handleRecalculate}
          disabled={!drawNum?.trim() || !(data?.matCards?.length > 0)}
        >
          重新計算
        </Button>
      </Box>

      <Dialog
        open={comparisonOpen}
        onClose={() => setComparisonOpen(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>批號與訂單數量比對</DialogTitle>
        <DialogContent>
          {comparisonLoading ? <div>查詢中...</div> : comparison && (
            <>
              <div className={`alert ${comparison.hasDifference ? 'alert-danger' : 'alert-success'}`}>
                批號：<b>{comparison.batchNo}</b>{' / '}
                圖號：<b>{comparison.drawNum}</b>{' / '}
                訂單數量：<b>{comparison.orderQuantity}</b>{' / '}
                出貨扣帳淨量：<b>{comparison.netShipmentPostedQuantity}</b>{' / '}
                差異：<b>{comparison.differenceQuantity}</b>
                {comparison.hasDifference ? '（數量不一致）' : '（數量一致）'}
              </div>

              <h5>訂單資料</h5>
              <div style={{ overflowX: 'auto' }}>
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr><th>訂單號碼</th><th>流水號</th><th>批號</th><th>圖號</th><th>訂單數量</th><th>實交貨數</th><th>累計交貨數</th><th>單位</th></tr>
                  </thead>
                  <tbody>
                    {(comparison.orders || []).map((row) => (
                      <tr key={row.id}>
                        <td>{row.orderNo}</td><td>{row.serialNo}</td><td>{row.batchNo}</td><td>{row.drawNum}</td>
                        <td>{row.orderQuantity}</td><td>{row.actualDeliveryQuantity}</td><td>{row.accumulatedDeliveryQuantity}</td><td>{row.unit}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <h5>資材卡資料</h5>
              <div style={{ overflowX: 'auto', maxHeight: 300 }}>
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr><th>日期</th><th>類別</th><th>單號</th><th>批號</th><th>入量</th><th>出量</th><th>庫存量</th><th>核准</th></tr>
                  </thead>
                  <tbody>
                    {(comparison.materialCards || []).map((row) => (
                      <tr key={row.id}>
                        <td>{row.date}</td><td>{row.kind}</td><td>{row.orderNum}</td><td>{row.piNum}</td>
                        <td>{row.inAmount}</td><td>{row.outAmount}</td><td>{row.stock}</td><td>{row.approve}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setComparisonOpen(false)}>關閉</Button>
        </DialogActions>
      </Dialog>

      {/* PDF 預覽 Dialog */}
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Button autoFocus color="inherit" onClick={handleClose}>
              列印預覽
            </Button>
          </Toolbar>
        </AppBar>
        <PDFViewer style={{ width: '100%', height: '100%' }}>
          {data?.matCards?.length ? <MyDocument data={data.matCards} /> : null}
        </PDFViewer>
      </Dialog>
    </>
  );
}

/* ---------------- PDF 樣式/文件：原樣保留 ---------------- */
Font.register({
  family: 'TaipeiSansTCBeta-Bold',
  src: 'path/to/TaipeiSansTCBeta-Bold.ttf',
});
Font.register({
  family: 'TaipeiSansTCBeta-Light',
  src: 'path/to/TaipeiSansTCBeta-Light.ttf',
});
const pageWidth = (24.1 * 72) / 2.54;
const pageHeight = (14 * 72) / 2.54;
const cellWidth = pageWidth / 8;

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 24,
    width: pageWidth,
    height: pageHeight,
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    fontFamily: 'TaipeiSansTCBeta-Bold',
    marginBottom: 10,
  },
  smallTitle: {
    fontSize: 12,
    textAlign: 'flex-start',
    fontFamily: 'TaipeiSansTCBeta-Light',
    marginBottom: 20,
  },
  tableContainer: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#000',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000',
    alignItems: 'center',
    height: 24,
  },
  tableHeaderCell: {
    fontSize: 12,
    width: cellWidth,
    borderRightWidth: 1,
    fontFamily: 'TaipeiSansTCBeta-Bold',
    borderColor: '#000',
    textAlign: 'center',
  },
  tableCell: {
    fontSize: 10,
    width: cellWidth,
    fontFamily: 'TaipeiSansTCBeta-Light',
    borderRightWidth: 1,
    borderColor: '#000',
    textAlign: 'center',
  },
});

const MyDocument = ({ data }) => (
  <Document>
    <Page size={{ width: pageWidth, height: pageHeight }} style={styles.page}>
      <View
        style={{
          position: 'absolute',
          top: 24,
          right: 24,
          textAlign: 'right',
          fontFamily: 'TaipeiSansTCBeta-Light',
          fontSize: 12,
        }}
      >
        <Text>{dayjs().format('YY/MM/DD')}</Text>
        <Text render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}頁次`} fixed />
      </View>
      <View style={styles.title}>
        <Text>福蒙精密工業股份有限公司</Text>
      </View>
      <View style={styles.title}>
        <Text>生管資材卡</Text>
      </View>
      <View style={styles.smallTitle}>
        <Text>
          圖號:{data[0]?.drawNum}         物品名:{data[0]?.itemName}
        </Text>
      </View>
      <View style={styles.tableContainer}>
        <Text style={styles.tableHeaderCell}>申請日期</Text>
        <Text style={styles.tableHeaderCell}>日期</Text>
        <Text style={styles.tableHeaderCell}>類別</Text>
        <Text style={styles.tableHeaderCell}>單號</Text>
        <Text style={styles.tableHeaderCell}>批號</Text>
        <Text style={styles.tableHeaderCell}>入量</Text>
        <Text style={styles.tableHeaderCell}>出量</Text>
        <Text style={styles.tableHeaderCell}>庫存量</Text>
      </View>
      {data.map((item, idx) => (
        <View key={idx} style={styles.tableRow}>
          <Text style={styles.tableCell} />
          <Text style={styles.tableCell}>{item.date}</Text>
          <Text style={styles.tableCell}>{item.kind}</Text>
          <Text style={styles.tableCell}>{item.orderNum}</Text>
          <Text style={styles.tableCell}>{item.piNum}</Text>
          <Text style={styles.tableCell}>{item.inAmount}</Text>
          <Text style={styles.tableCell}>{item.outAmount}</Text>
          <Text style={styles.tableCell}>{item.stock}</Text>
        </View>
      ))}
    </Page>
  </Document>
);
